type HouseNumberAndSuffix = {
    number: string;
    suffix: string;
};


type AddressData = { data: {}; label: string; value: string };

interface QuoteAddress {
    identifier?: string | undefined;
    buildingOrPropertyName?: string | undefined;
    locationDescription?: string | undefined;
    lotNumber?: string | undefined;
    flatOrUnitNumber?: string | undefined;
    flatOrUnitType?: string | undefined;
    floorOrLevelNumber?: string | undefined;
    floorOrLevelType?: string | undefined;
    houseNumber?: string | undefined;
    houseNumberSuffix?: string | undefined;
    streetName?: string | undefined;
    streetType?: string | undefined;
    streetSuffix?: string | undefined;
    postcode?: string | undefined;
    suburbOrPlaceOrLocality?: string | undefined;
    stateOrTerritory?: string | undefined;
    country?: string | undefined;
    unstructuredAddress?: string | undefined;
    postalAddress?: string | undefined;
    isEmpty: boolean;
}

interface AddressResult {
    eid?: string | undefined;
    buildingName?: string | undefined;
    country?: string | undefined;
    flatUnitNumber?: string | undefined;
    flatUnitType?: string | undefined;
    floorLevelNumber?: string | undefined;
    floorLevelType?: string | undefined;
    fullAddress?: string | undefined;
    locality?: string | undefined;
    lotNumber?: string | undefined;
    postal?: string | undefined;
    postcode?: string | undefined;
    state?: string | undefined;
    street?: string | undefined;
    street2?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    streetSuffix?: string | undefined;
    streetType?: string | undefined;
}

export type {
    AddressData,
    QuoteAddress,
    AddressResult
};

const splitNumberAndSuffix = (value: string) => {
    const result: HouseNumberAndSuffix = {
        number: "",
        suffix: "",
    };

    const lastLetter = value.substring(value.length - 1);
    if (/\d/.test(lastLetter)) {
        result.number = value;
    } else {
        result.number = value.substring(0, value.length - 1);
        result.suffix = lastLetter;
    }
    return result;
};

const splitStreetNumberAndSuffix = (value?: string) => {
    let result: HouseNumberAndSuffix = {
        number: "",
        suffix: "",
    };

    if (!value || value.trim().length === 0) {
        return result;
    }

    if (/-/.test(value)) {
        const res = value.split("-");
        const result1 = splitNumberAndSuffix(res[0]);
        const result2 = splitNumberAndSuffix(res[1]);
        result.number = result1.number.concat("-", result2.number);
        result.suffix = result1.suffix ? result1.suffix : result2.suffix;
        return result;
    }

    result = splitNumberAndSuffix(value);
    return result;
};

export const getQuoteAddress = (address: AddressResult): QuoteAddress => {
    const houseNumberAndSuffix = splitStreetNumberAndSuffix(address.streetNumber);
    const { number, suffix } = houseNumberAndSuffix;

    const quoteAddress = {
        buildingOrPropertyName: address.buildingName,
        lotNumber: address.lotNumber,
        flatOrUnitType: address.flatUnitType,
        flatOrUnitNumber: address.flatUnitNumber,
        floorOrLevelNumber: address.floorLevelNumber,
        floorOrLevelType: address.floorLevelType,
        country: address.country,
        houseNumber: number,
        houseNumberSuffix: suffix,
        streetSuffix: address.streetSuffix,
        streetType: address.streetType,
        streetName: address.streetName,
        suburbOrPlaceOrLocality: address.locality,
        stateOrTerritory: address.state,
        unstructuredAddress: address.fullAddress,
        postcode: address.postcode,
        postalAddress: address.postal,
        isEmpty: false,
    };

    return quoteAddress;
};